// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M0 3H24V18H0V3ZM4 20H20V22H4V20Z"}}]};

const Tv2FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tv-2-filled',
    ref,
    icon: element,
  },
));

Tv2FilledIcon.displayName = 'Tv2FilledIcon';

export default Tv2FilledIcon;
